import { fetchWithAuthRelogin } from '../utils/sessionRelogin';
import { getUsersApiBase } from '../utils/miniappAdminOnly';
import { getAuthChannel } from '../utils/miniappAccessToken';

function authOpts(token, extra = {}) {
  const opts = {
  headers: { Authorization: `Bearer ${token}`, ...extra.headers },
    ...extra,
  };
  if (getAuthChannel() === 'browser') {
    opts.credentials = 'include';
  }
  return opts;
}

export async function fetchMyPhones(token) {
  const base = getUsersApiBase();
  const res = await fetchWithAuthRelogin(`${base}/users/me/phones`, authOpts(token));
  if (!res.ok) throw new Error(`phones ${res.status}`);
  return res.json();
}

export async function setPrimaryPhone(token, phoneId) {
  const base = getUsersApiBase();
  const res = await fetchWithAuthRelogin(
    `${base}/users/me/primary-phone`,
    authOpts(token, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ phone_id: phoneId }),
    })
  );
  if (!res.ok) throw new Error(`primary-phone ${res.status}`);
  return res.json();
}

export async function fetchLoginMethods(token) {
  const base = getUsersApiBase();
  const res = await fetchWithAuthRelogin(`${base}/users/me/login-methods`, authOpts(token));
  if (!res.ok) throw new Error(`login-methods ${res.status}`);
  return res.json();
}

export async function linkTelegramWithInitData(token, initData) {
  const base = getUsersApiBase();
  const res = await fetchWithAuthRelogin(
    `${base}/users/me/link/telegram`,
    authOpts(token, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ initData }),
    })
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg =
      typeof data.detail === 'string' ? data.detail : data.detail?.message || `link-telegram ${res.status}`;
    throw new Error(msg);
  }
  return data;
}

export async function authVkId(accessToken, linkToken = null) {
  const base = getUsersApiBase();
  const headers = { 'Content-Type': 'application/json' };
  if (linkToken) {
    headers.Authorization = `Bearer ${linkToken}`;
  }
  const opts = {
    method: 'POST',
    headers,
    body: JSON.stringify({ access_token: accessToken }),
    credentials: 'include',
  };
  const res = await fetch(`${base}/auth/vk-id`, opts);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg = typeof data.detail === 'string' ? data.detail : data.detail?.message || `VK ${res.status}`;
    throw new Error(msg);
  }
  return data;
}
